// product grid/list
function listgridJavascript() {
Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', function(event) {
        Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
        this.classList.add('active');
        if(this.classList.contains('listv')){
            document.getElementById('product-grid').classList.add('product-list');
            document.getElementById('product-grid').classList.remove('product-grid');
        }else if(this.classList.contains('gridv')){
            document.getElementById('product-grid').classList.add('product-grid');
            document.getElementById('product-grid').classList.remove('product-list');
        }
    }); 
});
};
document.addEventListener("shopify:section:load", listgridJavascript);
listgridJavascript();

// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i];
      if (thisVideoEl.closest('media-gallery')) {
        continue;
      }
      videoHeight = thisVideoEl.clientHeight,
      videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

// document.addEventListener('DOMContentLoaded', () => {
//   setInterval(countDown, 1000);
//   countDown();

//   function countDown() {
//     const countCardSections = document.querySelectorAll('.countd_all');
//     countCardSections.forEach((countdownSection) => {
//       const countDownDate = new Date(countdownSection.getAttribute('data-date')).getTime();
//       const now = Date.now();
//       const distance = countDownDate - now;

//       const daysElement = countdownSection.querySelector('.main_cdays .wb_cdays');
//       const hoursElement = countdownSection.querySelector('.main_chours .wb_chours');
//       const minutesElement = countdownSection.querySelector('.main_cminutes .wb_cminutes');
//       const secondsElement = countdownSection.querySelector('.main_cseconds .wb_cseconds');

//       const messageElement = countdownSection.querySelector('.main_ctext');
//       if (distance < 0 || isNaN(countDownDate)) {
//         daysElement.textContent = "00";
//         hoursElement.textContent = "00";
//         minutesElement.textContent = "00";
//         secondsElement.textContent = "00";
//         if (messageElement && messageElement.textContent.trim() !== '') {
//           daysElement.parentElement.style.display = "none";
//           hoursElement.parentElement.style.display = "none";
//           minutesElement.parentElement.style.display = "none";
//           secondsElement.parentElement.style.display = "none";
//           countdownSection.style.display = "inline-block";
//           messageElement.style.display = "block";
//         }
//       } else {
//         daysElement.textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
//         hoursElement.textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//         minutesElement.textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//         secondsElement.textContent = Math.floor((distance % (1000 * 60)) / 1000);
//         if (messageElement) {
//           messageElement.style.display = "none";
//         }
//       }
//     });
//   }
// });

document.addEventListener("DOMContentLoaded", () => {
  const pad = v => String(v).padStart(2, "0");

  const countDown = () => {
    document.querySelectorAll(".countd_all").forEach(section => {
      const target = new Date(section.dataset.date).getTime();
      const diff = target - Date.now();

      const els = {
        d: section.querySelector(".main_cdays .wb_cdays"),
        h: section.querySelector(".main_chours .wb_chours"),
        m: section.querySelector(".main_cminutes .wb_cminutes"),
        s: section.querySelector(".main_cseconds .wb_cseconds"),
        msg: section.querySelector(".main_ctext")
      };

      if (diff < 0 || isNaN(target)) {
        ["d","h","m","s"].forEach(k => els[k].textContent = "00");

        if (els.msg && els.msg.textContent.trim()) {
          ["d","h","m","s"].forEach(k => els[k].parentElement.style.display = "none");
          section.style.display = "inline-block";
          els.msg.style.display = "block";
        }
      } else {
        els.d.textContent = Math.floor(diff / 86400000);
        els.h.textContent = Math.floor(diff % 86400000 / 3600000);
        els.m.textContent = Math.floor(diff % 3600000 / 60000);
        els.s.textContent = Math.floor(diff % 60000 / 1000);
        els.msg && (els.msg.style.display = "none");
      }
    });
  };
  countDown();
  setInterval(countDown, 1000);
});
